import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChecklistLine} from '@dropbox/dig-icons/assets';
import {useQuery} from '@tanstack/react-query';
import {EditordocService} from 'client';
import {NotificationCard} from 'components/notifications/NotificationCard';
import {notificationLinkTargetsThread} from 'components/notifications/utils/threadLink';
import {useNotificationContext} from 'components/notifications/utils/useNotificationContext';
import {TimeAgo} from 'components/shared/TimeAgo';
import {useCommentActions} from 'hooks/useCommentActions';
import {useEmployee} from 'hooks/useEmployee';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import {getService} from 'utilities';

export const DocumentMentionAdded = () => {
  const {
    notification: {archived, updated_at, data},
  } = useNotificationContext();
  const {to, data: jsonData} = data;
  const {planning_id: planningId, ldap, thread_id: threadId} = JSON.parse(jsonData);

  const {openComment} = useCommentActions();

  const {data: planning} = useQuery({
    queryKey: ['planning', planningId],
    queryFn: () => getService(EditordocService).getApiV1EditordocEncryptedIdGet(planningId),
  });

  const {employee} = useEmployee({ldap});

  if (!planning?.name) {
    return null;
  }

  const clickAction = (click: 'view' | 'archive') => {
    if (click === 'view') {
      if (threadId && !notificationLinkTargetsThread(to, threadId)) {
        openComment({threadId, source: 'notification'});
      }
    }
  };

  return (
    <NotificationCard
      accessory={<UIIcon src={ChecklistLine} className={atoms({color: 'Text Subtle'})} />}
      header={
        <Trans
          i18nKey="notification_document_mention_added"
          t={t}
          values={{planning: planning.name, author: employee?.name}}
          components={{
            b: <Text isBold />,
          }}
        />
      }
      truncate
      subtext={<TimeAgo timestamp={updated_at} />}
      to={to}
      archived={archived}
      clickAction={clickAction}
    />
  );
};
